import { render, staticRenderFns } from "./OrganizationNewEventPage.vue?vue&type=template&id=8a1701f8&"
import script from "./OrganizationNewEventPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationNewEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports